export const START_APP = 'events/START_APP';

/**
 * @return {{type: string}}
 */
export const startApp = () => ({ type: START_APP });
